import { apiClient } from './apiClient';

export class LawyerService {
    constructor() {
        this.BASE_URL = '/lawyers';
    }

    async getLawyerById(id) {
        try {
            const response = await apiClient.get(`${this.BASE_URL}/${id}`);
            return response;
        } catch (error) {
            console.error('Error fetching lawyer:', error);
            throw error;
        }
    }

    async fetchLawyers(params = {}) {
        try {
            const queryParams = new URLSearchParams();

            if (params.page) queryParams.append("page", params.page.toString());
            if (params.limit) queryParams.append("limit", params.limit.toString());
            if (params.firstName) queryParams.append('firstName', params.firstName);
            if (params.lastName) queryParams.append('lastName', params.lastName);
            // Entity filter support for UnifiedClaimsFilter
            if (params.name) queryParams.append('name', params.name);
            if (params.contact) queryParams.append('contact', params.contact);
            const sortBy = params.sortBy || 'name';
            const sortOrder = params.sortOrder || 'asc';
            queryParams.append('sortBy', sortBy);
            queryParams.append('sortOrder', sortOrder);

            // Using POST to a search endpoint is unconventional but followed as per original.
            // A GET request is generally preferred for fetching/searching data.
            const url = `${this.BASE_URL}/search?${queryParams.toString()}`;
            const response = await apiClient.post(url);

            return response;
        } catch (error) {
            console.error("Error fetching lawyers. Check network tab or server logs.");
            throw error;
        }
    }

    async createLawyer(data) {
        try {
            const response = await apiClient.post(this.BASE_URL, data);
            return response;
        } catch (error) {
            console.error('Error creating lawyer:', error);
            throw error;
        }
    }

    async updateLawyer(id, data) {
        try {
            const response = await apiClient.patch(`${this.BASE_URL}/${id}`, data);
            return response;
        } catch (error) {
            console.error('Error updating lawyer:', error);
            throw error;
        }
    }

    async deleteLawyer(id) {
        try {
            const response = await apiClient.delete(`${this.BASE_URL}/${id}`);
            return response;
        } catch (error) {
            console.error('Error deleting lawyer:', error);
            throw error;
        }
    }

    async mergeLawyers(payload) {
        try {
            const response = await apiClient.post(`${this.BASE_URL}/merge`, payload);
            return response;
        } catch (error) {
            console.error('Error merging lawyers:', error);
            throw error;
        }
    }

    async validateMerge(sourceId) {
        try {
            const response = await apiClient.get(`${this.BASE_URL}/merge-validate?sourceId=${sourceId}`);
            return response;
        } catch (error) {
            console.error('Error validating lawyer merge:', error);
            throw error;
        }
    }

    async searchFallbackLawyers(payload) {
        const response = await apiClient.post(`${this.BASE_URL}/fallback-search`, payload);
        return response;
    }

    async importFallbackLawyer(payload) {
        const response = await apiClient.post(`${this.BASE_URL}/import-fallback`, payload);
        return response;
    }
}

// Singleton instance
export const lawyerService = new LawyerService();
export default lawyerService;
